<template>
  <div>
    <div class="printBtnBox">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <div id="print" class="printContent">
      <div v-for="item in inStockBill" :key="item.pkid" class="printContainer">
        <div class="printItem">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <td rowspan="3" style="width: 130px">
                <div :id="'qrCode' + item.billNo" align="center"/>
              </td>
              <td colspan="2" style="font-weight: 700; font-size: 12pt" align="center">调拨单</td>
            </tr>
            <tr>
              <td>调拨单号：{{item.billNo}}</td>
              <td>单据类型：{{item.transferTypeName}}</td>
            </tr>
            <tr>
              <td>制作人：{{item.creatorName}}</td>
              <td>处理时间：{{item.handleTime}}</td>
            </tr>
            <tr>
              <td colspan="3">备注：{{item.note}}</td>
            </tr>
          </table>
        </div>
        <div class="printItem">
          <table cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th align="center">物料编号</th>
                <th>老料号</th>
                <th>物料名称</th>
                <th align="center">调出仓库</th>
                <th align="center">调出小仓位</th>
                <th align="center">库存</th>
                <th align="center">调入仓库</th>
                <th align="center">调入小仓位</th>
                <th align="center">调拨数</th>
                <th align="center">单位</th>
              </tr>
            </thead>
            <tr v-for="i in item.details" :key="i.pkId">
              <td align="center">{{i.materialNo}}</td>
              <td align="center">{{i.mappingMaterialNo}}</td>
              <td style="width: 125px">{{i.materialName}}</td>
              <td align="center">{{constant.locationNo[i.outLocationNo]}}</td>
              <td align="center">{{i.outWarehouseNo}}</td>
              <td align="center">{{i.stockQuantity}}</td>
              <td align="center">{{constant.locationNo[i.inLocationNo]}}</td>
              <td align="center">{{i.inWarehouseNo}}</td>
              <td align="center">{{i.quantity}}</td>
              <td align="center">{{i.unit}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import QRCode from "qrcodejs2";
  import constant from "@/util/constant";
  export default {
    data() {
      return {
        constant,
        inStockBill: [],
      };
    },

    mounted() {
      this.getData(JSON.parse(this.$route.query.params));
    },

    methods: {
      getData(ids) {
        this.$http.post("basic", "transferBills/details", ids).then((resp) => {
          console.log(resp);
          this.inStockBill = resp.data;
          for (let item of this.inStockBill) {
            this.$nextTick(() => {
              document.getElementById("qrCode" + item.billNo).innerHTML = "";
              this.bindQRCode(item.billNo);
            });
          }
        });
      },

      bindQRCode(code) {
        new QRCode(document.getElementById("qrCode" + code), {
          text: code,
          width: 110,
          height: 110,
          colorDark: "#000000", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      printHandle() {
        document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
        window.print();
        window.close();
      },
    },
  };
</script>

<style lang="scss" scoped>
.printBtnBox {
  width: 195mm; margin: 0 auto; padding: 2mm 0; position: fixed; top: 0; left: -10cm; margin-left: 50%;background-color: #fff;z-index: 999;
}
.printItem {
  width: 195mm;
  font-size: 10pt;
  margin: 10px auto;
  color: #000;
  font-weight: 500;
  font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif;
  word-break: break-all;
  line-height: 1.1;
  table {
    width: 100%;
    border: 1px solid #000;
    border-collapse: collapse;
    tr {
      td, th {
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        padding:2px 1px;
        word-break: break-all;
        font-size: 10pt;
        &:last-child {
          border-right: none;
        }
      }
      &:last-child td {
        border-bottom: none;
      }
    }
  }
}
.printContent {
  padding-top: 50px;
}
@media print {
  .printContainer{
    margin: 0;
    page-break-inside: avoid; // 避免在打印项内部分页
  }
  .printContainer:not(:last-child) {
    page-break-after: always;
  }
  .printItem{
    margin: 0;
  }
  .printBtnBox{
    display: none;
  }
  .printContent {
    padding-top: 0;
  }
}
</style>
